import type { FaireProductEntity } from "../../entity_types/product";

export const p_dr9s882d26: FaireProductEntity = {
  token: "p_dr9s882d26",
  type: "product",
  name: "Goddess Car Diffuser",
  brandName: "Misha Hawaii Home",
  imageUrl:
    "https://cdn.faire.com/fastly/aaa6fe173be4690b2a13927f8a846c2fa72349db76e25c4c5c3e385387761a2a.png",
  priceDollars: 8.5,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/0efd8d14c6e70e35b3b74a6f586e973c92e860ee35a42470daec0ac1ad25ea00.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
